import React from 'react';
import clsx from 'clsx';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import ToolTip from 'core/components/Tooltip';
import {
  telehealthProviderNotConfiguredTooltip,
  telehealthVisitScheduledTooltip,
} from 'utils/telehealth';

type Props = {
  isTelehealthVisitType: boolean;
  isTelehealthEnabledForProvider: boolean;
};

export default function TelehealthVisitTypeIcon({
  isTelehealthVisitType,
  isTelehealthEnabledForProvider,
}: Props) {
  const isEnabled = isTelehealthEnabledForProvider;
  const tooltipTitle = isEnabled
    ? telehealthVisitScheduledTooltip
    : telehealthProviderNotConfiguredTooltip;

  return isTelehealthVisitType ? (
    <ToolTip title={tooltipTitle}>
      <span
        className={clsx('inline-flex items-center shrink-0', {
          'text-green-600': isEnabled,
          'text-gray-600 opacity-60': !isEnabled,
        })}
      >
        <VideocamOutlinedIcon className="!h-5 !w-5" />
      </span>
    </ToolTip>
  ) : null;
}
